import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { formatDateToDDMMYYYY } from '../../utils/dateUtils';
import '../GL/GeneralLoanDueReport.css';

const CDLoanDueReport = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDueReport();
  }, []);

  const fetchDueReport = async () => {
    setLoading(true);
    try {
      const params = {};
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;

      const response = await axios.get(`${API_BASE_URL}/api/cd-loan-due-report`, { params });
      setReportData(response.data);
    } catch (error) {
      console.error('Error fetching due report:', error);
      alert('Failed to fetch due report');
    } finally {
      setLoading(false);
    }
  };

  const handleDateFilter = () => {
    fetchDueReport();
  };

  const handleBackClick = () => {
    window.history.back();
  };

  return (
    <div className="due-report-container">
      <button onClick={handleBackClick} className="back-button">Back</button>
      
      <div className="due-report-header">
        <h2>CD Loan Due Report</h2>
      </div>

      <div className="date-filter-section">
        <div className="date-input-group">
          <label>From Date:</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="date-input-group">
          <label>To Date:</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <button onClick={handleDateFilter} className="filter-button">
          Apply Filter
        </button>
      </div>

      {loading ? (
        <div className="loading-message">Loading...</div>
      ) : (
        <div className="table-container">
          <table className="due-report-table">
            <thead>
              <tr>
                <th>Account No</th>
                <th>Loanee Name & Phone</th>
                <th>Guarantor Name & Phone</th>
                <th>Maturity Date</th>
                <th>Balance on Maturity Date</th>
                <th>Outstanding Balance</th>
              </tr>
            </thead>
            <tbody>
              {reportData.length === 0 ? (
                <tr>
                  <td colSpan="6" className="no-data">No due records found</td>
                </tr>
              ) : (
                reportData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.account_no}</td>
                    <td className="name-phone-cell">
                      <div className="name">{item.loanee_name}</div>
                      <div className="phone">{item.phone_debtor || 'N/A'}</div>
                    </td>
                    <td className="name-phone-cell">
                      <div className="name">{item.guarantor_name || 'N/A'}</div>
                      <div className="phone">{item.phone_guarantor || 'N/A'}</div>
                    </td>
                    <td>
                      {formatDateToDDMMYYYY(item.maturity_date)}
                    </td>
                    <td className="balance-cell">
                      ₹{item.remaining_amount.toFixed(2)}
                    </td>
                    <td className="outstanding-cell">
                      ₹{item.outstanding_balance.toFixed(2)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CDLoanDueReport;

